import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { ArbeitstageSelect } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/ArbeitstageSelect';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { BerechnungsgrundlageDreiMonatsdurchschnitt } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/berechnungsgrundlageDreiMonatsDurchschnitt';
import { berechnungsgrundlageDreiMonatsschnitt } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/berechnungsgrundlageDreiMonatsschnitt';
import { RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function DreiMonatsdurchschnittFields() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <form.AppField name="abwesenheiten.allgemein.dynamisch_drei_monatsschnitt_berechnungsgrundlage">
      {(field) => (
        <div className="flex flex-col gap-4">
          <FieldBase
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.label',
            )}>
            <RadioGroup
              value={field.state.value}
              onValueChange={(e) =>
                field.handleChange(
                  e as BerechnungsgrundlageDreiMonatsdurchschnitt,
                )
              }
              className="flex flex-row">
              <RadioGroupItem
                variant="card"
                layout="horizontal"

                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.options.moegliche_arbeitstage',
                )}
                value={
                  berechnungsgrundlageDreiMonatsschnitt.moegliche_arbeitstage
                }
                className="w-full"
              />
              <RadioGroupItem
                variant="card"
                layout="horizontal"
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.options.anzahl_sv_tage',
                )}
                value={berechnungsgrundlageDreiMonatsschnitt.anzahl_sv_tage}
                className="w-full"
              />
            </RadioGroup>
          </FieldBase>
          {field.state.value === 'moegliche_arbeitstage' && (
            <ArbeitstageSelect disableOptionFlexibel />
          )}
        </div>
      )}
    </form.AppField>
  );
}
